module.exports = __webpack_public_path__ + "img/c5201909.d79d1386.jpg";